import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { reduxForm, Field, destroy, initialize } from 'redux-form';
import {
  InputFieldComponent,
  TextareaFieldComponent,
} from '../../atoms/atoms.index';
import { useDispatch } from 'react-redux';
import { resetUsers } from '../../../store/users/users.actions';
import { required } from '../../../utils/FormValidators';
import { EFormName } from '../../../config/form-names.config';
import { IContactResume } from '../../../domain/contact.interface';
import { DatepickerComponent } from '../../atoms/date-picker/DatePicker.component';
import './AddEditContactModalForm.component.scss';

function AddEditContactModalFormComponent(props: any) {
  const {
    showModal,
    handleClose,
    handleSubmit,
    submitAddContact,
    submitEditContact,
    contact,
    propsEditMode,
  } = props;
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [contactInfo, setContactInfo] = useState<any>(undefined);

  useEffect(() => {
    if (propsEditMode) {
      setEditMode(true);
    } else {
      setEditMode(false);
    }
    setContactInfo(contact);
    // eslint-disable-next-line
  }, [contact]);

  useEffect(() => {
    if (!!contactInfo) {
      const body = { ...contactInfo };
      dispatch(initialize(EFormName.ADD_EDIT_CONTACT, body));
    } else {
      setContactInfo(undefined);
    }
    // eslint-disable-next-line
  }, [contactInfo]);

  function resetModal() {
    handleClose();
    setContactInfo(undefined);
    dispatch(destroy(EFormName.ADD_EDIT_CONTACT));
    dispatch(resetUsers());
  }

  return (
    <Modal show={showModal} onHide={() => resetModal()} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {editMode ? (
            <FormattedMessage id='organisms.add-edit-contact-modal-form.edit-title' />
          ) : (
            <FormattedMessage id='organisms.add-edit-contact-modal-form.add-title' />
          )}
        </Modal.Title>
      </Modal.Header>
      <form
        className='new-list-form'
        name={EFormName.ADD_EDIT_CONTACT}
        autoComplete='off'
        onSubmit={handleSubmit((values: IContactResume) => {
          setContactInfo(undefined);
          editMode ? submitEditContact(values) : submitAddContact(values);
        })}
      >
        <Modal.Body>
          <div className='form-field-container'>
            <FormattedMessage id='organisms.add-edit-contact-modal-form.alias'>
              {(txt: any) => (
                <Field
                  name={'alias'}
                  component={InputFieldComponent}
                  label={txt}
                  validate={[required]}
                />
              )}
            </FormattedMessage>
            {!!contactInfo && contactInfo.user.nickname && (
              <div className='username-container d-flex flex-column'>
                <div>
                  <span className='label'>
                    <FormattedMessage id='common.username' />:
                  </span>
                  <span className='value'>{`${contactInfo.user.nickname}`}</span>
                </div>
                <div>
                  <span className='label'>
                    <FormattedMessage id='common.name-surname' />:
                  </span>
                  {contactInfo.user.name !== null && (<span className='value'>{`${contactInfo.user.name}`}</span>)}
                </div>
              </div>
            )}
            <div className='date-container'>
              <Field
                name={'birthday'}
                component={DatepickerComponent}
                placeholder='organisms.add-edit-contact-modal-form.birthday'
                maxDate={new Date()}
                date={!!contactInfo ? contactInfo.birthday : undefined}
                formName={EFormName.ADD_EDIT_CONTACT}
                fieldName='birthday'
              />
            </div>
            <FormattedMessage id='organisms.add-edit-contact-modal-form.notes'>
              {(txt: any) => (
                <Field
                  name={'comments'}
                  component={TextareaFieldComponent}
                  label={txt}
                  validate={[]}
                />
              )}
            </FormattedMessage>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className='btn-lili form-button danger mb-3 cancel-btn'
            onClick={() => resetModal()}
          >
            <FormattedMessage id='common.cancel'></FormattedMessage>
          </button>
          <button className='btn-lili form-button  mb-3' type='submit'>
            <FormattedMessage id='common.save'></FormattedMessage>
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default reduxForm({
  form: EFormName.ADD_EDIT_CONTACT,
})(AddEditContactModalFormComponent);
